import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Shield, LogIn, AlertCircle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/admin/login`, { email, password });
      localStorage.setItem("rpc_admin_token", data.token);
      navigate("/admin");
    } catch (err) {
      setError(err?.response?.data?.detail || "Error al iniciar sesión");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0d2140] px-5">
      <div className="w-full max-w-md bg-white rounded-3xl p-8 shadow-2xl">
        <div className="flex items-center gap-2 justify-center mb-6">
          <span className="flex items-center justify-center w-11 h-11 rounded-lg bg-[#0d2140]">
            <Shield className="w-6 h-6 text-[#f5871f]" />
          </span>
          <span className="font-display font-700 text-[#0d2140] text-2xl">GRUPO <span className="text-[#f5871f]">RPC</span></span>
        </div>
        <h1 className="font-display font-700 text-xl uppercase text-[#0d2140] text-center">Panel de administración</h1>
        <p className="text-[#0d2140]/50 text-sm text-center mt-1 mb-6">Ingrese sus credenciales</p>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="text-xs font-600 uppercase tracking-wide text-[#0d2140]/60">Correo</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
              className="mt-1.5 w-full rounded-xl border border-[#0d2140]/15 px-4 py-3 focus:outline-none focus:border-[#f5871f] focus:ring-2 focus:ring-[#f5871f]/20" />
          </div>
          <div>
            <label className="text-xs font-600 uppercase tracking-wide text-[#0d2140]/60">Contraseña</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
              className="mt-1.5 w-full rounded-xl border border-[#0d2140]/15 px-4 py-3 focus:outline-none focus:border-[#f5871f] focus:ring-2 focus:ring-[#f5871f]/20" />
          </div>
          {error && <p className="flex items-center gap-2 text-red-600 text-sm"><AlertCircle className="w-4 h-4" />{error}</p>}
          <button type="submit" disabled={loading}
            className="btn-orange w-full inline-flex items-center justify-center gap-2 rounded-xl px-6 py-3.5 font-700 uppercase tracking-wide font-display disabled:opacity-60">
            {loading ? "Ingresando..." : "Ingresar"} <LogIn className="w-4 h-4" />
          </button>
        </form>
      </div>
    </div>
  );
}
